// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import Login from './pages/Login.vue'
import Dashboard from './pages/Dashboard.vue'
import CtvRegister from './pages/CtvRegister.vue'
import Sign from './pages/Sign.vue'
import { setToken } from './api/client'

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', component: Login },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/register-ctv', component: CtvRegister, meta: { requiresAuth: true } },
  { path: '/sign', component: Sign, meta: { requiresAuth: true } },

] 

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() { return { top: 0 } }
})

router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('ctv_token')
  if (token) setToken(token)
  if (to.meta.requiresAuth && !token) return next('/login')
  if (to.path === '/login' && token) return next('/dashboard')
  next()
})

window.addEventListener('auth-changed', () => {
  const token = localStorage.getItem('ctv_token')
  setToken(token || null)
})

export default router
